import { useStore } from "@/store";
import { computed } from "vue";
export function usePower() {
  const store = useStore();
  const powerList = computed(() => store.state.userInfo?.power_arr);
  const power = (id) => {
    const arr = [].concat(id);
    return powerList.value?.some((item) => arr.some((_item) => _item === item));
  };
  return {
    power,
  };
}
